(function () {
  var BASE_MS = 2500;
  var JITTER_MS = 1200;
  var START_SPREAD_MS = 1600;
  var TRANSITION_MS = 580;
  var CARD_SEL = ".product-card.product-card--bb";
  var SWAP_LINK_SEL = ".bb-card__media-link.image-swap";
  var GLOBO_CARD_SEL = ".spf-product-card--bb-layout";
  var SIZE_CHART_RE = /size[\s_-]*chart|sizechart|\u0645\u0642\u0627\u0633/i;

  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  var timers = new WeakMap();
  var watched = new WeakSet();

  function isPaused(el) {
    if (el.matches(":hover")) return true;
    var active = document.activeElement;
    return !!(active && el.contains(active));
  }

  function cardInterval(el) {
    if (!el.dataset.bbSlideMs) {
      el.dataset.bbSlideMs = String(BASE_MS + Math.floor(Math.random() * (JITTER_MS + 1)));
    }
    return parseInt(el.dataset.bbSlideMs, 10) || BASE_MS;
  }

  function isSizeChartImage(img) {
    if (!img) return false;
    var hay = [
      img.getAttribute("alt") || "",
      img.getAttribute("src") || "",
      img.getAttribute("data-src") || ""
    ].join(" ");
    return SIZE_CHART_RE.test(hay);
  }

  function mediaRoot(el) {
    return (
      el.querySelector(".bb-card__media-link.image-swap, .spf-product-card__image-wrapper") || el
    );
  }

  function slidesOf(el) {
    var root = mediaRoot(el);
    var imgs = root.querySelectorAll("img");
    var out = [];
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (isSizeChartImage(img)) continue;
      if (img.classList.contains("hidden")) continue;
      out.push(img);
    }
    return out;
  }

  function hasSlideableImages(el) {
    return slidesOf(el).length > 1;
  }

  function resolveLazySrc(img) {
    var dataSrc = img.getAttribute("data-src");
    if (!dataSrc) return;
    if (dataSrc.indexOf("{width}") !== -1) {
      img.src = dataSrc.replace("{width}", "540");
    } else if (!img.getAttribute("src") || img.getAttribute("src").indexOf("data:image") === 0) {
      img.src = dataSrc;
    }
    img.removeAttribute("srcset");
  }

  function unveilImg(img) {
    if (!img) return;
    img.classList.add("lazypreload");
    if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.unveil === "function") {
      window.lazySizes.loader.unveil(img);
    }
    resolveLazySrc(img);
  }

  function whenReady(img, cb) {
    if (!img) {
      cb();
      return;
    }
    unveilImg(img);
    if (img.complete && img.naturalWidth > 1) {
      cb();
      return;
    }
    var settled = false;
    var done = function () {
      if (settled) return;
      settled = true;
      img.removeEventListener("load", done);
      img.removeEventListener("error", done);
      cb();
    };
    img.addEventListener("load", done);
    img.addEventListener("error", done);
    window.setTimeout(done, 3500);
  }

  function parkSlide(img) {
    if (!img) return;
    img.classList.remove("is-bb-slide-active", "is-bb-slide-exit");
    img.classList.add("is-bb-slide-park");
  }

  function resetSlides(el) {
    var slides = slidesOf(el);
    el.dataset.bbSlideI = "0";
    slides.forEach(function (img, i) {
      img.classList.toggle("is-bb-slide-active", i === 0);
      img.classList.toggle("is-bb-slide-park", i !== 0);
      img.classList.remove("is-bb-slide-exit");
    });
  }

  function goTo(el, to) {
    var slides = slidesOf(el);
    if (slides.length < 2) return;
    var from = parseInt(el.dataset.bbSlideI || "0", 10) || 0;
    if (from === to) return;
    var prev = slides[from];
    var next = slides[to];
    var state = timers.get(el);
    if (state && state.resetId) {
      window.clearTimeout(state.resetId);
      state.resetId = 0;
    }
    if (prev) {
      prev.classList.remove("is-bb-slide-active", "is-bb-slide-park");
      prev.classList.add("is-bb-slide-exit");
    }
    if (next) {
      next.classList.remove("is-bb-slide-park", "is-bb-slide-exit");
      void next.offsetWidth;
      next.classList.add("is-bb-slide-active");
    }
    el.dataset.bbSlideI = String(to);
    unveilImg(slides[(to + 1) % slides.length]);
    var parkPrev = function () {
      parkSlide(prev);
      if (state) state.resetId = 0;
    };
    if (state) {
      state.resetId = window.setTimeout(parkPrev, TRANSITION_MS);
    } else {
      window.setTimeout(parkPrev, TRANSITION_MS);
    }
  }

  function tick(el) {
    var state = timers.get(el);
    if (!state || state.busy) return;
    var slides = slidesOf(el);
    if (slides.length < 2) return;
    var from = parseInt(el.dataset.bbSlideI || "0", 10) || 0;
    var to = (from + 1) % slides.length;
    var next = slides[to];
    state.busy = true;
    whenReady(next, function () {
      state.busy = false;
      if (!el.isConnected || isPaused(el)) return;
      if (!timers.has(el)) return;
      goTo(el, to);
    });
  }

  function start(el) {
    if (timers.has(el) || !hasSlideableImages(el)) return;
    var state = { timeoutId: 0, intervalId: 0, resetId: 0, busy: false };
    timers.set(el, state);
    resetSlides(el);
    var slides = slidesOf(el);
    unveilImg(slides[1]);
    whenReady(slides[1], function () {
      if (!timers.has(el) || !el.isConnected || !hasSlideableImages(el)) return;
      var ms = cardInterval(el);
      var delay = Math.floor(Math.random() * START_SPREAD_MS);
      state.timeoutId = window.setTimeout(function () {
        if (!timers.has(el) || !el.isConnected) return;
        tick(el);
        state.intervalId = window.setInterval(function () {
          if (!el.isConnected) {
            stop(el);
            return;
          }
          if (isPaused(el)) return;
          tick(el);
        }, ms);
      }, delay);
    });
  }

  function stop(el) {
    var state = timers.get(el);
    if (state) {
      window.clearTimeout(state.timeoutId);
      window.clearInterval(state.intervalId);
      window.clearTimeout(state.resetId);
    }
    timers.delete(el);
    resetSlides(el);
  }

  var inFrame = false;
  try {
    inFrame = window.self !== window.top;
  } catch (err) {
    inFrame = true;
  }

  var io =
    !inFrame && "IntersectionObserver" in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) start(entry.target);
              else stop(entry.target);
            });
          },
          { rootMargin: "200px 0px", threshold: 0.05 }
        )
      : null;

  function watch(el) {
    if (!el || watched.has(el) || !hasSlideableImages(el)) return;
    watched.add(el);
    if (io) io.observe(el);
    else start(el);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(CARD_SEL).forEach(function (card) {
      if (card.querySelector(SWAP_LINK_SEL) && hasSlideableImages(card)) watch(card);
    });
    scope.querySelectorAll(GLOBO_CARD_SEL).forEach(function (card) {
      var wrap = card.querySelector(".spf-product-card__image-wrapper");
      if (!wrap) return;
      if (hasSlideableImages(card)) {
        wrap.classList.add("hover-effect");
        watch(card);
      }
    });
  }

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    scan(document);

    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (
            node.matches &&
            (node.matches(CARD_SEL) ||
              node.matches(GLOBO_CARD_SEL) ||
              node.querySelector(CARD_SEL) ||
              node.querySelector(GLOBO_CARD_SEL))
          ) {
            scan(node);
          }
        }
      }
    });

    mo.observe(document.body, { childList: true, subtree: true });
  });
})();
